import type React from 'react';
import { CardHeader, Divider, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import type { RequestProps } from '../../models';
import { Status } from './Status';

const style = {
	divider: { borderBottomWidth: 1.5 },
};

interface StatusInfoProps {
	status: RequestProps['status'];
}

export const StatusInfo: React.FC<StatusInfoProps> = ({ status }) => (
	<>
		<CardHeader title="Status" />
		<Divider sx={style.divider} />
		<CardContent>
			<Grid container spacing={2}>
				<Grid size={{ xs: 6 }}>
					<Status status={status} clickable={false} />
				</Grid>
			</Grid>
		</CardContent>
	</>
);
